import gql from 'graphql-tag';
import { compose } from 'recompose';
import { get } from 'utils';
import { graphql } from 'graphql/utils';
import { watchlistFragment } from 'graphql/fragments/watchlists';

export const withData = () =>
    compose(
        graphql(
            gql`
                query withUserWatchlists {
                    currentUser {
                        id
                        watchlists {
                            ...watchlist
                        }
                    }
                }
                ${watchlistFragment}
            `,
            {
                props: ({ data }) => ({
                    watchlists: [
                        ...get(data, 'currentUser.watchlists', []).map(({ watchlistId, name }) => ({
                            value: watchlistId,
                            label: name
                        }))
                    ]
                }),
                options: {
                    fetchPolicy: 'cache-first'
                }
            }
        )
    );
